import React from 'react'

import IconPickerModal from '../IconPickerModal'

import Dropzone from '../../blocks/editable/Dropzone'

import General from '../../../utils/General'
import { updateIconValue } from '../../constants/utils'

export default class IconSettingsModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      iconInfo: props.iconInfo,
      showModal: false,
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderModal(iconInfo){

    return (
      <IconPickerModal
        show={this.state.showModal}
        onHide={() => this.setState({ showModal: false })}
        currentIcon={iconInfo.icon}
        useCondition="fa-check"
        onSelected={(type, icon, closeModal, directUpdate) => {
          iconInfo.icon = directUpdate ? icon : updateIconValue(type, iconInfo.icon, icon)
          this.setState({
            iconInfo,
            showModal: closeModal ? false : true
          })
          this.props.onUpdated(iconInfo)
        }}
      />
    )
  }

  render(){
    let { iconInfo } = this.state

    return (
      <>
        <a href="javascript:void(0)"
           className="edit"
           onClick={() => this.setState({ showModal: true })}>
             <i className="icon icon--xs icon-Pencil" />
        </a>
        { this._renderModal(iconInfo) }
      </>
    )
  }
}
